export class ConfirmationDialogData {
  title?: string;
  content?: string;
  additionalContent?: string;
  confirmBtnName?: string;
  cancelBtnName?: string;
  hideCancelBtn?: boolean;

  constructor(
    title: string = null,
    content: string = null,
    additionalContent: string = null,
    confirmBtnName: string = null,
    cancelBtnName: string = null,
    hideCancelBtn: boolean = false
  ) {
    this.title = title;
    this.content = content;
    this.additionalContent = additionalContent;
    this.confirmBtnName = confirmBtnName;
    this.cancelBtnName = cancelBtnName;
    this.hideCancelBtn = hideCancelBtn;
  }
};
